<mat-card class="activities-card inner-scroll mat-elevation-z0 qcmContainer"
  [ngClass]="{'two-columns-layout': isTwoColumns}"
  [attr.id]="type === 'isWordSelecting' || type === 'isLetterSelecting'?'type-is-word-or-lettersSelecting':''">

  <mat-card-header>
    <mat-card-title [class.sub-instruction-enabled]="showSubInstruction">
      @if (isConsigneContainMedia(wording) || (!isDataEmpty(wording) && !isDataEmpty(wordingAudio)) || (!isDataEmpty(wording) && isDataEmpty(wordingAudio))) {
        <app-consignes
          (isReading)="ttsReadingEvent($event)"
          [wording]="wording" [ngClass]="{'consigneImg': isWordingImg()}"
          [wordingAudio]="wordingAudio"
          [additionalHiddenText]="showSubInstruction?('activities.sub_instruction_qmc' | translate):''"
          [autoRead]="isAutoReadActive('wording')" [readable]="!isConsigneContainMedia(wording)"
        ></app-consignes>
      }
      @if (showSubInstruction) {
        <h2 [ngClass]="isTTSReading?.value ? 'read-in-progress' : 'read-not-in-progress'"
        >{{ 'activities.sub_instruction_qmc' | translate }}</h2>
      }
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    @if (isConsigneContainMedia(instruction) || (!isDataEmpty(instruction) && !isDataEmpty(instructionAudio)) || (!isDataEmpty(instruction) && isDataEmpty(instructionAudio))) {
      <app-consignes
        [instruction]="instruction" [ngClass]="{'consigneImg': isInstructionImg()}"
        [instructionAudio]="instructionAudio"
        [autoRead]="isAutoReadActive('instruction')" [readable]="!isConsigneContainMedia(instruction)"
        questionTypeName="{{ 'activities.questionTypeName.app-qcm' | translate }}">
      </app-consignes>
    }

    @for (f of referenceActivityGranule?.flashcards; track f) {
      <app-flashcard [class.button-image]="f.image"
        [class.is-audio]="f.audio?.uri"
        [flashCard]="f">
      </app-flashcard>
    }
    <!--checkbox-group pose soucis-->
    <div class="checkbox-group"
      [ngClass]="parentClass()">
      @if (isWrapperForCheckbox && !answerContainImg && !areAnswersContainAudio()) {
        <div>
          @for (option of availableAnswers | intToBoolean: 'correct_answer':'select' ; let index = $index; track option) {
            <div
              class="checkbox-wrapper" (click)="toggleCheck($event, option)" [ngClass]="optionState(option)">
              <mat-checkbox
                [ngModel]="isAnswerSelected(option)"
                [disabled]="isDisabledOptions()"
                [ngClass]="optionState(option)"
                [disableRipple]="true"
                [value]="option.answer">
                <span [innerHTML]="option.answer | stringToHtml"></span>
              </mat-checkbox>
            </div>
          }
        </div>
      }
      @if (!isWrapperForCheckbox && !answerContainImg && !areAnswersContainFlashcard() && !areAnswersContainAudio()) {
        @for (option of availableAnswers | intToBoolean: 'correct_answer':'select' ; let index = $index; track option) {
          <div
            >
            @if (!option.image || option.image === '') {
              <mat-checkbox
                (keydown.enter)="toggleCheck($event, option)"
                [ngModel]="isAnswerSelected(option)"
                (change)="toggleCheck($event, option)"
                [disabled]="isDisabledOptions()"
                [ngClass]="optionState(option)"
                [disableRipple]="true"
                [value]="option.answer">
                <span [innerHTML]="option.answer | stringToHtml"></span>
              </mat-checkbox>
            }
          </div>
        }
      }

      @if (answerContainImg) {
        @for (option of availableAnswers | intToBoolean: 'correct_answer':'select' ; let index = $index; track option) {
          <div
            (click)="toggleCheck($event, option)"
            [ngClass]="optionState(option)" class="button-image">
            @if (option.image && option.image !== '') {
              <div>
                <!-- TODO add alt text to the image, set in the back -->
                <img [attr.id]="'imgToZoom' + uuid + index.toString()" [src]="option.image"/>
                @if (isImageFullscreenButtonEnabled()) {
                  <div class="action-buttons">
                    <app-zoomable [uuid]="uuid" [index]="index"></app-zoomable>
                  </div>
                }
              </div>
            }
          </div>
        }
      }

      @if (areAnswersContainFlashcard() && !answerContainImg) {
        @for (option of availableAnswers | intToBoolean: 'correct_answer':'select' ; let index = $index; track option) {
          @if (option.flashcards) {
            @for (flashcard of option.flashcards; track flashcard) {
              <app-flashcard
                [class.button-image]="flashcard.image"
                [class.is-audio]="flashcard.audio?.uri"
                [ngClass]="optionState(option)"
                [flashCard]="flashcard"
                (click)="toggleCheck($event, option)">
              </app-flashcard>
            }
          }
        }
      }

      @if (areAnswersContainAudio()) {
        @for (option of availableAnswers | intToBoolean: 'correct_answer':'select' ; let index = $index; track option) {
          <button
            class="qcm__audio-button"
            [ngClass]="optionState(option)"
            (click)="playAudioAndToggleCheck($event, option.audio.id, option)">
            <mat-icon [svgIcon]="'qcm-qcu__audio-' + (index + 1)"></mat-icon>
            @if (option.audio) {
              <audio
                [src]="option.audio.uri"
                [id]="option.audio.id">
              </audio>
            }
          </button>
        }
      }

    </div>

  </mat-card-content>

  @if (displayFeedback) {
    <div class="answer-state-msg wrongreply">
      <p>{{ feedback | translate }}</p>
    </div>
  }

  <mat-card-footer>
    @if (isPercentileDisplayAllowed) {
      <div class="gradePercentil"
        >{{ 'generic.score' | translate }}{{ showPercentile }}
      </div>
    }
    @if (!isActivityEmbeddedDone) {
      @if (displaySaveBtn) {
        <button
          class="btn-option"
          [class]="buttonState"
          [disabled]="isDisabledOptions(false)"
          (click)="validate()">
          <span>{{ 'generic.register_' + buttonState | translate }}</span>
          <mat-icon svgIcon="{{'qcm__register__' + buttonState}}"></mat-icon>
        </button>
      }
      @for (button of buttons; track button) {
        @if (button.display) {
          <button
            [disabled]="button.disable"
            (click)="onAction(button)">
            <span>{{ button.title | translate }}</span>
            @if (button.svgIcon) {
              <mat-icon [svgIcon]="button.svgIcon"></mat-icon>
            }
          </button>
        }
      }
    }
  </mat-card-footer>
</mat-card>
@if (!!feedbackFromApi && isActivityEmbeddedDone) {
  <app-activities-feedback
    (action)="actionFromFeedback($event)"
    [activityType]="activityType"
    [feedback]="feedbackFromApi"
    [buttons]="feedbackButtons"
    [answerStatus]="answerStatus">
  </app-activities-feedback>
}
